var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_vm.navComponent, {
    tag: "component",
    attrs: { workspaceId: _vm.workspaceId, projectId: _vm.projectId },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }